<template>
  <BootErrorBanner />

  <router-view />

  <TolgeeProvider>
    <template v-if="false">
      <!-- VuePreloader temporarily disabled to fix console errors -->
      <!-- TODO: Re-enable after fixing component registration -->
    </template>
  </TolgeeProvider>
  <AppToaster />
  <OfflineOverlay />
  <CacheRefreshOverlay />
  <BackendUnavailableBanner />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
// VuePreloader component temporarily removed - causing console errors
// The component is imported but Vue cannot resolve it at runtime
// Need to either:
// 1. Register it globally in main boot file, or
// 2. Use a proper Quasar Loading component instead
// import { VuePreloader } from 'vue-preloader';
import { TolgeeProvider } from '@tolgee/vue';
import OfflineOverlay from 'src/components/OfflineOverlay.vue';
import { CacheRefreshOverlay } from 'src/components/UpdateNotification';
import BootErrorBanner from 'src/components/BootErrorBanner.vue';
import BackendUnavailableBanner from 'src/components/BackendUnavailableBanner.vue';
export default defineComponent({
  components: {
    // VuePreloader,
    TolgeeProvider,
    OfflineOverlay,
    CacheRefreshOverlay,
    BootErrorBanner,
    BackendUnavailableBanner,
  },
  name: 'App',
  mounted() {
    const loader = document.getElementById('app-loading');
    if (loader) {
      loader.remove();
    }
    // Signal to the preboot error-capture script that the app successfully mounted.
    // This stops it from reporting us as "stuck" and lets it flush any buffered errors.
    if (typeof window !== 'undefined') {
      window.__appInitialized = true;
      // DPT-252: clear the mount-watchdog retry counter on a successful mount so
      // a later deploy-staleness in this tab gets a fresh set of recovery reloads.
      try {
        sessionStorage.removeItem('dbx_mount_retry');
      } catch (e) {
        /* storage blocked — non-fatal */
      }
    }
  },
});
</script>
